module.exports = __webpack_public_path__ + "assets/images/project/brunei.jpg?v=a81223ed";